/* Dados para a Conversions API (CAPI): fbp/fbc/fbclid.
   - O pixel do Meta cria os cookies _fbp e _fbc (a partir do ?fbclid= da URL) quando carrega na pagina.
   - Aqui so LEMOS esses cookies.
   1) Lista VIP: preenche campos ocultos do RD, se existirem (se nao existirem, nada acontece), e avisa o pixel
      (correspondencia avancada manual) do e-mail/telefone/nome; o pixel normaliza e faz hash.
   2) Compra: grava _fbp/_fbc nos atributos do carrinho (/cart/update.js). A Shopify leva esses atributos para o pedido
      (note_attributes), e e dali que o servidor le o clique do anuncio na hora do Purchase.
   Roda em fase de captura, antes do handler de submit da lista VIP (assets/zaiare-lista-vip.js). Nao altera o envio. */
(function(){
  var PIXEL_ID = '2233047077494870';
  function cookie(n){ var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  try{ var id = new URLSearchParams(location.search).get('fbclid'); if(id) sessionStorage.setItem('zr_fbclid', id); }catch(e){}
  function fbclid(){ try{ return sessionStorage.getItem('zr_fbclid') || ''; }catch(e){ return ''; } }
  function fbc(){ var c = cookie('_fbc'); if(c) return c; var id = fbclid(); return id ? ('fb.1.' + Date.now() + '.' + id) : ''; }
  function setField(box, name, val){
    if(!val) return;
    var el = box.querySelector('[name="' + name + '"], [name="cf_' + name + '"]');
    if(el){ el.value = val; el.dispatchEvent(new Event('input', {bubbles:true})); el.dispatchEvent(new Event('change', {bubbles:true})); }
  }

  // 2) atributos do carrinho: no maximo uma vez por sessao e so se o valor mudou
  function syncCart(){
    try{
      var fp = cookie('_fbp'), fc = fbc();
      if(!fp && !fc) return;
      var sig = fp + '|' + fc;
      if(sessionStorage.getItem('zr_cart_sig') === sig) return;
      var attrs = {};
      if(fp) attrs._fbp = fp;
      if(fc) attrs._fbc = fc;
      fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({ attributes: attrs }) })
        .then(function(r){ if(r.ok) sessionStorage.setItem('zr_cart_sig', sig); })
        .catch(function(){});
    }catch(e){}
  }
  // o cookie _fbp so existe depois que o pixel carrega: tenta de novo algumas vezes
  var tries = 0;
  (function wait(){ if(cookie('_fbp') || tries++ > 10){ syncCart(); return; } setTimeout(wait, 700); })();

  // 1) lista VIP
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!f || !f.closest || !f.closest('[data-zv-vip]')) return;
    var box = document.querySelector('.zv-rd-hidden');
    if(box){
      setField(box, 'fbp', cookie('_fbp'));
      setField(box, 'fbc', fbc());
      setField(box, 'fbclid', fbclid());
      setField(box, 'client_user_agent', navigator.userAgent);
    }
    try{
      var em = f.querySelector('input[type=email]'), ph = f.querySelector('input[type=tel]'), nm = f.querySelector('input[name=name]');
      var mail = em ? em.value.trim().toLowerCase() : '';
      if(window.fbq && /^[^@ ]+@[^@ ]+[.][^@ ]+$/.test(mail)){
        var d = ph ? ph.value.replace(/[^0-9]/g, '') : '';
        var data = { em: mail };
        if(d.length === 10 || d.length === 11) data.ph = '55' + d;
        var first = nm ? nm.value.trim().split(/ +/)[0] : '';
        if(first) data.fn = first.toLowerCase();
        fbq('init', PIXEL_ID, data);
      }
    }catch(err){}
  }, true);
})();
